<template>
    <div>
        <h1 class="tw:text-3xl tw:font-bold tw:md:text-4xl">{{ title }}<br>- {{ title2 }}</h1>
        <p class="tw:mt-2 tw:max-w-prose tw:text-zinc-600">
            {{ subTitle }}
        </p>
    </div>
</template>

<script setup>
    const title = window.TABS.$t('Bestill pakke eller book kursplass');
    const title2 = window.TABS.$t('Raskt og enkelt');
    const subTitle = window.TABS.$t('Bestill kjøretimer, kursplass og mye annet på nett.');
</script>
